/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TopicDestinationRoute
 */
export interface TopicDestinationRoute {
    /**
     * The topic destination route ID.
     * @type {string}
     * @memberof TopicDestinationRoute
     */
    id: string;
    /**
     * The ID of the topic.
     * @type {string}
     * @memberof TopicDestinationRoute
     */
    topicId: string;
    /**
     * The ID of the destination.
     * @type {string}
     * @memberof TopicDestinationRoute
     */
    destinationId: string;
    /**
     * The Ampersand project ID.
     * @type {string}
     * @memberof TopicDestinationRoute
     */
    projectId: string;
    /**
     * The time when the topic destination route was created.
     * @type {Date}
     * @memberof TopicDestinationRoute
     */
    createTime: Date;
}

/**
 * Check if a given object implements the TopicDestinationRoute interface.
 */
export function instanceOfTopicDestinationRoute(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "topicId" in value;
    isInstance = isInstance && "destinationId" in value;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "createTime" in value;

    return isInstance;
}

export function TopicDestinationRouteFromJSON(json: any): TopicDestinationRoute {
    return TopicDestinationRouteFromJSONTyped(json, false);
}

export function TopicDestinationRouteFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopicDestinationRoute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'topicId': json['topicId'],
        'destinationId': json['destinationId'],
        'projectId': json['projectId'],
        'createTime': (new Date(json['createTime'])),
    };
}

export function TopicDestinationRouteToJSON(value?: TopicDestinationRoute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'topicId': value.topicId,
        'destinationId': value.destinationId,
        'projectId': value.projectId,
        'createTime': (value.createTime.toISOString()),
    };
}

